import References from '../ui/References';
import { connect } from 'react-redux';
import { hostProfileSubmit, skipSubmit, goBack } from '../../actions';

const mapStateToProps = (state, props) =>
  ({
    page: state.page,
    intl: props.intl,
    user: state.user,
    content: state.content,
    profileElements: state.profileElements,
    activeProfileElements: state.activeProfileElements,
    requiredFields: state.requiredFields
  });

const mapDispatchToProps = dispatch =>
  ({
    onHostProfileSubmit(payload) {
       dispatch(
         hostProfileSubmit(payload)
       );
    },
    onSkipSubmit(payload) {
       dispatch(
         skipSubmit(payload)
       );
    },
    onGoBack(payload) {
       dispatch(
         goBack(payload)
       );
    }
  });

const Container = connect(mapStateToProps, mapDispatchToProps)(References);

export default Container;
